import React, { useState, useEffect } from 'react';
import { Box, Button, Menu, MenuItem } from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';

const LANG_NAMES = {
  ro: 'RO',
  ru: 'RU',
  en: 'EN',
};

// Глобальное событие для смены языка
const LANG_CHANGE_EVENT = 'app:langChange';

export function getCurrentLang() {
  return localStorage.getItem('app_lang') || 'ro';
}

export function setLang(lang) {
  localStorage.setItem('app_lang', lang);
  window.dispatchEvent(new CustomEvent(LANG_CHANGE_EVENT, { detail: lang }));
}

const LangSelector = () => {
  const [lang, setLangState] = useState(getCurrentLang);
  const [anchor, setAnchor] = useState(null);

  useEffect(() => {
    const handler = (e) => setLangState(e.detail);
    window.addEventListener(LANG_CHANGE_EVENT, handler);
    return () => window.removeEventListener(LANG_CHANGE_EVENT, handler);
  }, []);

  const handleSelect = (l) => {
    setLang(l);
    setAnchor(null);
  };

  return (
    <>
      <Button
        size="small"
        onClick={(e) => setAnchor(e.currentTarget)}
        sx={{
          minWidth: 48,
          borderRadius: '8px',
          fontWeight: 700,
          fontSize: '13px',
          color: '#6366f1',
          border: '1px solid #6366f1',
          textTransform: 'none',
          gap: 0.5,
        }}
        startIcon={<LanguageIcon sx={{ fontSize: 16 }} />}
      >
        {LANG_NAMES[lang] || 'RO'}
      </Button>
      <Menu
        anchorEl={anchor}
        open={Boolean(anchor)}
        onClose={() => setAnchor(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        {Object.entries(LANG_NAMES).map(([key, label]) => (
          <MenuItem
            key={key}
            selected={key === lang}
            onClick={() => handleSelect(key)}
            sx={{ fontSize: 14, minWidth: 100, justifyContent: 'center' }}
          >
            {label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default LangSelector;
